import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface PoConfirmDialogData {
  title: string;
  message: string;
  confirmLabel: string;
}

@Component({
  selector: 'app-po-confirm-dialog',
  templateUrl: './po-confirm-dialog.component.html',
  styleUrls: ['./po-confirm-dialog.component.scss'],
})
export class PoConfirmDialogComponent {
  constructor(
    public readonly dialogRef: MatDialogRef<PoConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public readonly data: PoConfirmDialogData,
  ) {}

  cancel(): void {
    this.dialogRef.close(false);
  }

  confirm(): void {
    this.dialogRef.close(true);
  }
}
